module.exports = __webpack_public_path__ + "img/audit_report.e4f68b84.svg";